import { useState } from 'react';
import { useDIContext } from '@/Framework/DI/DIContext';
import { getErrorMessage } from '@/Framework/Message/Mapper/getMessage';
import { AlertManager } from '@dealroadshow/uikit/core/components/Alert';
import LandingRepository from '@/dataroom/infrastructure/repository/LandingRepository';

const usePeriods = () => {
  const { container } = useDIContext();

  const [isFetching, setIsFetching] = useState<boolean>(false);
  const [collection, setCollection] = useState<{
    value: string,
    label: string,
  }[]>([]);

  const getPeriods = async () => {
    setIsFetching(true);

    try {
      const landingRepository = container.get<LandingRepository>(LandingRepository);
      const response = await landingRepository.getPeriods();

      const collection = response.map(({ id, displayName }) => ({
        value: id,
        label: displayName,
      }));

      setCollection(collection);
    } catch (error) {
      AlertManager.error(getErrorMessage(error));
    } finally {
      setIsFetching(false);
    }
  };

  return {
    isFetching,
    collection,
    getPeriods,
  };
};

export default usePeriods;
